// Components
import { IconLogo, Link } from '@tracklib/kit'

// Hooks
import { useIsAuthenticated } from 'modules/auth/hooks'
import { useFeatureToggle } from 'modules/featuretoggles/hooks'

import styles from './header.css'

type HeaderProps = {
  title: string
  description: string
  image?: string
}

const Header = ({ title, description, image }: HeaderProps): JSX.Element => {
  const isAuthenticated = useIsAuthenticated()
  const anniversaryDiscountFeatureToggle = useFeatureToggle('anniversaryDiscount')
  return (
    <div
      className={styles.wrapper}
      style={
        image || anniversaryDiscountFeatureToggle
          ? {
              backgroundImage: anniversaryDiscountFeatureToggle ? 'url(/static/images/anniversary-subscribe-bg.png)' : `url("${image}")`,
            }
          : {}
      }
    >
      <Link to={isAuthenticated ? '/inspiration/' : '/'}>
        <IconLogo className={styles.logo} />
      </Link>
      {anniversaryDiscountFeatureToggle ? (
        <div className={styles.imageOverride} />
      ) : (
        <>
          <header className={styles.header}>
            <h1 className={styles.title} datatesting="subscribe_header_desc">
              {title}
            </h1>
            <p
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          </header>
        </>
      )}
    </div>
  )
}

export default Header
